<template>
  <div>
    <div>
      <el-button
        type="primary"
        plain
        @click="addUser"
        :disabled="!orgCode && name != 'admin'"
        >新增用户</el-button
      >
      <el-select
        v-model="orgCode"
        filterable
        clearable
        :disabled="name != 'admin'"
        placeholder="请选择机构"
      >
        <el-option
          v-for="item in orgOptions"
          :key="item.id"
          :label="item.orgName"
          :value="item.orgCode"
        >
        </el-option>
      </el-select>
      <el-button @click="getpage(1)">筛选</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list">
        <el-table-column align="center" label="用户名">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.username }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="机构名称">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              getName(scope.row.orgCode)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="机构码" prop="orgCode">
        </el-table-column>

        <el-table-column align="center" label="创建日期">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="修改日期">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.updateTime }}</span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >修改</el-button
            > -->

            <el-popconfirm
              title="你确定要删除该条目吗？"
              @onConfirm="handleDelete(scope.$index, scope.row)"
            >
              <el-button
                style="margin: 0 10px"
                size="mini"
                type="danger"
                slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
    <el-dialog :title="diaName" :visible.sync="dialogVisible" width="60%">
      <el-form :inline="true" ref="form" :model="form" label-width="120px">
        <el-form-item label="机构" required>
          <el-select
            v-model="form.orgCode"
            filterable
            :disabled="name != 'admin'"
            placeholder="请选择机构"
            @change="changeTable()"
          >
            <el-option
              v-for="item in orgOptions"
              :key="item.id"
              :label="item.orgName"
              :value="item.orgCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item required>
          <el-input
            v-model="form.username"
            @change="changeTable()"
            clearable
            placeholder="用户名,手机号,真实姓名筛选"
          ></el-input>
        </el-form-item>
        <el-button type="primary" size="default" @click="getUserData()"
          >查询</el-button
        >
      </el-form>
      <div>
        <el-table
          :data="userDate"
          border
          stripe
          height="500px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column align="center" label="用户名">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>姓名: {{ scope.row.username }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.username }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column align="center" label="真实姓名">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.realName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="机构码">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.orgCode }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page
        @givePageIndex="getpage1"
        :index="pagedia"
        :pageSize="pageSize"
        :total="totaldia"
      ></page>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import treeSelect from "../../components/treeSelect";
import page from "../../components/pages";
export default {
  components: {
    treeSelect,
    page,
  },
  created() {
    this.name = sessionStorage.getItem("admin");
    this.$api.aiUserOrgList().then((res) => {
      this.orgOptions = res.data.data;
      if (this.name !== "admin") {
        this.orgCode = this.orgOptions.length
          ? this.orgOptions[0].orgCode
          : undefined;
      } else {
        this.orgCode = undefined;
      }
    });
    this.load();

    // this.$api.structureList().then((res) => {
    //   // aiUserOrgList
    //   // console.log(res)
    //   if (res.data.code == 200) {
    //     this.orgBack = true;

    //     this.orgOption = res.data.data;
    //     // let orgid = sessionStorage.getItem("orgId");
    //     // console.log(orgid);
    //     // let code = this.orgOption.find((item) => item.id == orgid).code;
    //     // this.orgCode = code;

    //     this.load();
    //   } else {
    //     this.load();
    //   }
    // });
  },
  mounted() {},
  data() {
    return {
      grp: 0,
      openStat: 0,
      orgBack: false,
      search: "",
      name: "",
      orgCode: "",
      page: 1,
      pagedia: 1,
      pageSize: 10,
      totaldia: 0,
      total: 0,
      list: [],
      userDate: [],
      orgOptions: [],
      userOptions: [],
      orgOption: [],
      multipleSelection: [],
      dialogVisible: false,
      tree: false,
      form: {
        orgCode: "", //机构id
        orgCode1: "",
        username: "",
      },
      diaName: "新增用户",
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getName(row) {
      return this.orgOptions.find((item) => item.orgCode == row)?.orgName;
    },
    //打开新增用户页面，请求树形组件内容
    addUser() {
      this.diaName = "新增用户";
      this.form = {
        orgCode1: undefined,
        orgCode: undefined,
        username: "",
      };
      this.form.orgCode = this.orgOptions[0].orgCode;
      this.loadUser();
      //   if (this.name != "admin") {
      //     this.form.orgCode1 = Number(sessionStorage.getItem("orgId"));
      //     let org = this.orgOption.find(
      //       (item) => item.id == this.form.orgCode1
      //     )?.code;
      //     this.form.orgCode = org;
      //     this.loadUser();
      //   }else{

      //   }
      this.pagedia = 1;
      this.getUserData();
      this.dialogVisible = true;
    },
    resetTree() {
      this.form.orgCode1 = "";
      this.form.orgCode = "";
      this.form.username = "";
    },
    changeTable() {
      this.pagedia = 1;
      this.getUserData();
    },

    getUserData() {
      let obj = {
        pageNo: this.pagedia,
        pageSize: 10,
        search: this.form.username,
        orgCode: this.form.orgCode,
      };
      this.$api.AppUserList(obj).then((res) => {
        if (res.data.code == 200) {
          this.userDate = res.data.data.records;
          this.pagedia = res.data.data.current;
          this.totaldia = res.data.data.total;
        }
      });
    },
    add() {
      if (!this.multipleSelection || this.multipleSelection.length !== 1) {
        this.$message({
          message: "请选择一个用户",
          type: "warning",
        });
        return;
      }
      let obj = this.multipleSelection[0];
      const param = {
        orgCode: obj.orgCode,
        username: obj.username,
      };
      this.$api
        .aiUserSave(param)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.load();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    orgall(x) {
      this.orgCode = x.code;
      // this.form.department = x.name;
    },
    handleEdit(index, row) {
      this.diaName = "修改用户";
      let org =
        this.orgOption.find((item) => item.code == row.orgCode)?.id || "1";
      this.$set(this.form, "orgCode1", org);
      this.form.orgCode = row.orgCode;
      this.form.username = row.username;
      this.form.startTime = row.startTime;
      this.form.endTime = row.endTime;
      this.form.id = row.id;
      this.loadUser();

      this.dialogVisible = true;
    },

    //删除用户
    handleDelete(index, row) {
      this.$api.aiUserDelete(row.id).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.load();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    formorgall(x) {
      this.form.orgCode = x.code;
      this.form.username = "";
      this.loadUser();
    },
    loadUser() {
      let obj = {
        pageNo: 1,
        pageSize: 99999,
        orgCode: this.form.orgCode,
      };
      console.log(obj);
      this.$api.AppUserList(obj).then((res) => {
        console.log(res.data.data.records);

        if (res.data.code == 200) {
          this.userOptions = res.data.data.records;
        }
      });
    },
    load() {
      let obj = {
        search: this.search,
        pageNo: this.page,
        pageSize: this.pageSize,
        orgCode: this.orgCode ? this.orgCode : undefined,
      };
      console.log(obj);
      this.$api.aiUserList(obj).then((res) => {
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    getpage1(x) {
      //分页
      this.pagedia = x;
      this.getUserData();
    },
    getpage(x) {
      //分页
      this.page = x;
      this.load();
    },
  },
};
</script>
  
  <style scoped>
</style>